import { React, useEffect ,useContext} from "react";
import { useTranslation } from 'react-i18next';
import * as menu from "../../assets/menus/menu.js";
import { ServiceScreenLabels } from '../_label/service_screen/service_screen_labels.js';
import UserContext from '../../components/User_Context.js';
import * as api from "../../api/apiConnector.js";

function AfterLoginErrorScreen() {
  
  const { t } = useTranslation();
  const { doLogout } = useContext(UserContext);

  // Initialize i18n labels from centralized file
  const i18n = menu.getI18n();
  i18n.addResourceBundle('it', 'labels', ServiceScreenLabels.it, true, true);
  i18n.addResourceBundle('en', 'labels', ServiceScreenLabels.en, true, true);

  // Hide navigation elements when component mounts
  useEffect(() => {
    (async () => {
      window.$(".deznav").hide();
      window.$(".content-body").removeClass("content-body");
      window.$("#main-wrapper").addClass("menu-toggle");
      window.$(".hamburger").parent().hide();
      window.$(".header-content").hide();
      window.$(".nav-header").hide();
      window.$(".page-titles").hide();
      window.$(".header").hide();
    })();
  }, []);

  // Handle redirect to login page
  const handleLoginRedirect = () => {
    window.document.location.href = "/login";
  };

  const logout = async () => {
    var logoutURL = await api.sendMessage("security/oauthLogout", {

        body: {
        }
    });
    var result = await doLogout();





    if(logoutURL && logoutURL.url && logoutURL.url !=''){
        document.location.href=logoutURL.url;
    }else{
        document.location.href = "/";

    }


}


  return (
    <div className="bg-white vh-100 vw-100 d-flex align-items-center justify-content-center">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            <div className="bg-light p-5 rounded-3 text-center shadow-sm">
              <h1 className="display-6 fw-bold text-dark mb-4">
                {t('loginError', { ns: 'labels' })}
              </h1>
              {/* <button 
                onClick={handleLoginRedirect}
                className="btn btn-primary btn-lg px-4 py-2 me-3"
                type="button"
              >
                {t('retry', { ns: 'labels' })}
              </button> */}

              <button 
                onClick={()=>{logout()}}
                className="btn btn-primary btn-lg px-4 py-2"
                type="button"
              >
                {t('retry', { ns: 'labels' })}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AfterLoginErrorScreen;
